import Swal from "sweetalert2";
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Panel from "@/shared/components/Panel";
import React, { useState, useEffect } from "react";
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ClicksChartWrap = styled.div`
  margin-top: -30px;
`;

const ElastiCacheStoredData = () => {
    const [charData, setCharData] = useState();
    const themeName = useSelector(state => state.theme.className);

    const handleModalClose = () => {
        setCharData(null);
    };

    const getElastiCacheStoreData = () => {
        AdminInterface.instance.getElastiCacheStoredData().then((response) => {
            response.data['Timestamps'] = response.data['Timestamps'].slice().reverse();
            response.data['Values'] = response.data['Values'].slice().reverse();
            let chart_data = response.data['Timestamps'].map((timestamp, idx) => ({
                Timestamp: (new Date(timestamp)).toLocaleString(),
                'Stored Data (MB)': parseFloat(response.data['Values'][idx].toFixed(2))
            }));
            setCharData(chart_data);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    };

    useEffect(() => {
        getElastiCacheStoreData();
    }, []);

    return (
        <Panel lg={6} xl={6} md={12} title='ElastiCache Stored Data' subhead='Last 24 hours' dismissButton={() => handleModalClose()} refreshRequest={() => getElastiCacheStoreData()}>
            {charData && <ClicksChartWrap dir="ltr">
                <ResponsiveContainer height={500}>
                    <LineChart width={730} height={500} data={charData} margin={{ top: 5, right: 30, left: 20, bottom: 100 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="Timestamp" tick={{ angle: -45, textAnchor: 'end' }}/>
                        <YAxis label={{ value: 'Megabytes', angle: -90, position: 'insideLeft' }} />
                        <Tooltip />
                        <Line type="monotone" dataKey="Stored Data (MB)" stroke="#8884d8" strokeWidth={2} fill="#8884d8"/>
                    </LineChart>
                </ResponsiveContainer>
            </ClicksChartWrap>}
        </Panel>
    );
};

export default ElastiCacheStoredData;